import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";

import Welcome from "@/pages/Welcome";
import Payment from "@/pages/Payment";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CreateProfile from "@/pages/CreateProfile";
import Dashboard from "@/pages/Dashboard";
import IdealWeight from "@/pages/IdealWeight";
import Progress from "@/pages/Progress";
import Meals from "@/pages/Meals";
import Snacks from "@/pages/Snacks";
import Supplements from "@/pages/Supplements";
import RoutinesWomen from "@/pages/RoutinesWomen";
import RoutinesMen from "@/pages/RoutinesMen";
import Fasting from "@/pages/Fasting";
import MuscleGain from "@/pages/MuscleGain";
import Hydration from "@/pages/Hydration";
import Tips from "@/pages/Tips";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ChangePassword from "@/pages/ChangePassword";
import AdminManualPayments from "@/pages/AdminManualPayments";
import AdminPanel from "@/pages/AdminPanel";
import AlimentacionCuba from "@/pages/AlimentacionCuba";
import AcceptInvitation from "@/pages/AcceptInvitation";
import EditProfile from "@/pages/EditProfile";
import MyPlan from "@/pages/MyPlan";
import TrainingLog from "@/pages/TrainingLog";
import Calisthenics from "@/pages/Calisthenics";
import MealLog from "@/pages/MealLog";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/pago" element={<Payment />} />
            <Route path="/pago/exito" element={<PaymentSuccess />} />
            <Route path="/pago/cancelado" element={<PaymentCancel />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/olvide-contrasena" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/aceptar-invitacion" element={<AcceptInvitation />} />
            <Route path="/admin" element={<ProtectedRoute requireProfile={false}><AdminPanel /></ProtectedRoute>} />
            <Route path="/admin/pagos-cuba" element={<ProtectedRoute requireProfile={false}><AdminManualPayments /></ProtectedRoute>} />
            <Route path="/cambiar-contrasena" element={<ProtectedRoute requireProfile={false}><ChangePassword /></ProtectedRoute>} />
            <Route path="/crear-perfil" element={<ProtectedRoute requireProfile={false}><CreateProfile /></ProtectedRoute>} />
            <Route path="/editar-perfil" element={<ProtectedRoute><EditProfile /></ProtectedRoute>} />
            <Route path="/alimentacion-cuba" element={<ProtectedRoute><AlimentacionCuba /></ProtectedRoute>} />
            <Route path="/panel" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/peso-ideal" element={<ProtectedRoute><IdealWeight /></ProtectedRoute>} />
            <Route path="/progreso" element={<ProtectedRoute><Progress /></ProtectedRoute>} />
            <Route path="/mi-plan" element={<ProtectedRoute><MyPlan /></ProtectedRoute>} />
            <Route path="/libreta" element={<ProtectedRoute><TrainingLog /></ProtectedRoute>} />
            <Route path="/calistenia" element={<ProtectedRoute><Calisthenics /></ProtectedRoute>} />
            <Route path="/mi-comida" element={<ProtectedRoute><MealLog /></ProtectedRoute>} />
            <Route path="/comidas" element={<ProtectedRoute><Meals /></ProtectedRoute>} />
            <Route path="/snacks" element={<ProtectedRoute><Snacks /></ProtectedRoute>} />
            <Route path="/suplementos" element={<ProtectedRoute><Supplements /></ProtectedRoute>} />
            <Route path="/rutinas-mujeres" element={<ProtectedRoute><RoutinesWomen /></ProtectedRoute>} />
            <Route path="/rutinas-hombres" element={<ProtectedRoute><RoutinesMen /></ProtectedRoute>} />
            <Route path="/ayuno" element={<ProtectedRoute><Fasting /></ProtectedRoute>} />
            <Route path="/ganar-masa" element={<ProtectedRoute><MuscleGain /></ProtectedRoute>} />
            <Route path="/hidratacion" element={<ProtectedRoute><Hydration /></ProtectedRoute>} />
            <Route path="/consejos" element={<ProtectedRoute><Tips /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
